/* eslint-disable no-console */

export const state = () => ({
  posts: [],
  postsPagination: null,
  hubTags: [],
  singlePost: {},
  postsLoading: false,
  postsError: '',
  singlePostLoading: false,
  singlePostError: '',
  page: {},
  pageLoading: false,
  pageError: '',
})

export const getters = {
  posts(state) {
    return state.posts
  },
  postsPagination(state) {
    return state.postsPagination
  },
  hubTags(state) {
    return state.hubTags
  },
  singlePost(state) {
    return state.singlePost
  },
  postsError(state) {
    return state.postsError
  },
  postsLoading(state) {
    return state.postsLoading
  },
  singlePostError(state) {
    return state.singlePostError
  },
  singlePostLoading(state) {
    return state.singlePostLoading
  },
  page(state) {
    return state.page
  },
  pageError(state) {
    return state.pageError
  },
  pageLoading(state) {
    return state.pageLoading
  },
}

export const mutations = {
  SET_POSTS: (state, posts) => {
    state.posts = posts
  },
  SET_POSTS_PAGINATION: (state, pagination) => {
    state.postsPagination = pagination
  },
  SET_HUB_TAGS: (state, tags) => {
    state.hubTags = tags
  },
  SET_SINGLE_POST: (state, singlePost) => {
    state.singlePost = singlePost
  },
  SET_POSTS_LOADING: (state, payload) => {
    state.postsLoading = payload
  },
  SET_POSTS_ERROR: (state, payload) => {
    state.postsError = payload
  },
  SET_SINGLE_POST_LOADING: (state, payload) => {
    state.singlePostLoading = payload
  },
  SET_SINGLE_POST_ERROR: (state, payload) => {
    state.singlePostError = payload
  },
  SET_PAGE: (state, payload) => {
    state.page = payload
  },
  SET_PAGE_ERROR: (state, payload) => {
    state.pageError = payload
  },
  SET_PAGE_LOADING: (state, payload) => {
    state.pageLoading = payload
  },
}

export const actions = {
  async loadPosts({ commit }, { page = 1, tag = null } = {}) {
    commit('SET_POSTS_LOADING', true)
    try {
      const data = await this.$axios.$get('/api/blog/v1/posts', {
        params: tag ? { page, tag } : { page },
      })
      commit('SET_POSTS', data.posts)
      commit('SET_POSTS_PAGINATION', data.pagination)
      commit('SET_POSTS_LOADING', false)
      commit('SET_POSTS_ERROR', '')
    } catch (error) {
      console.log('SET_POSTS error', error)
      commit('SET_POSTS', [])
      commit('SET_POSTS_PAGINATION', null)
      commit('SET_POSTS_LOADING', false)
      commit('SET_POSTS_ERROR', error)
      // this.$sentry.captureException(new Error(error))
    }
  },
  async loadHubTags({ commit }) {
    try {
      commit('SET_HUB_TAGS', await this.$axios.$get('/api/blog/v1/tags'))
    } catch (error) {
      console.log('SET_HUB_TAGS error', error)
      // The hub nav is an enhancement; the listing renders fine without it.
      commit('SET_HUB_TAGS', [])
    }
  },
  async loadSinglePost({ commit }, slug) {
    commit('SET_SINGLE_POST_LOADING', true)
    try {
      const singlePost = await this.$axios.$get(`/api/blog/v1/post/${slug}`)
      commit('SET_SINGLE_POST', singlePost)
      commit('SET_SINGLE_POST_LOADING', false)
      commit('SET_SINGLE_POST_ERROR', '')
    } catch (error) {
      console.log('SET_SINGLE_POST error', error)
      commit('SET_SINGLE_POST', null)
      commit('SET_SINGLE_POST_LOADING', false)
      commit('SET_SINGLE_POST_ERROR', error)
    }
  },
  async loadPage({ commit }, slug) {
    commit('SET_PAGE_LOADING', true)
    try {
      const page = await this.$axios.$get(`/api/blog/v1/static-page/${slug}`)
      commit('SET_PAGE', page)
      commit('SET_PAGE_LOADING', false)
      commit('SET_PAGE_ERROR', '')
    } catch (error) {
      console.log('SET_PAGE error', error)
      commit('SET_PAGE', null)
      commit('SET_PAGE_LOADING', false)
      commit('SET_PAGE_ERROR', error)
    }
  },
}
